import React from "react";
import Sidebar from "./Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlusCircle,
  faEye,
  faEdit,
  faList,
  faLayerGroup,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import "./manageSections.css";
import { useNavigate } from "react-router-dom";

const ManageSections = () => {
  const navigate = useNavigate();

  return (
    <div className="manage-sections-screen">
      <div className="manage-sections-dashboard-wrapper">
        <Sidebar />
        <div className="manage-sections-main-content">
          <section className="manage-sections-content">
            <div className="manage-sections-content-header">
              <h1 className="manage-sections-main-title">
                Manage Class Sections
              </h1>
              <p className="manage-sections-subtitle">
                Organize and manage class sections across your institution
              </p>
            </div>

            {/* Two horizontal cards container */}
            <div className="manage-sections-cards-container">
              {/* Add Sections Card (Left - 45%) */}
              <div className="manage-sections-card manage-sections-add-card">
                <div className="manage-sections-card-header">
                  <div className="manage-sections-header-icon-wrapper">
                    <FontAwesomeIcon
                      icon={faPlusCircle}
                      className="manage-sections-card-icon"
                    />
                  </div>
                  <div>
                    <h3 className="manage-sections-card-title">
                      Create New Sections
                    </h3>
                    <p className="manage-sections-card-subtitle">
                      Add new sections to any class with detailed configurations
                    </p>
                  </div>
                </div>

                <div className="manage-sections-card-features">
                  <div className="manage-sections-feature-item">
                    <div className="manage-sections-feature-icon">
                      <FontAwesomeIcon icon={faLayerGroup} />
                    </div>
                    <div className="manage-sections-feature-content">
                      <h4 className="manage-sections-feature-title">
                        Create Multiple Sections
                      </h4>
                      <p className="manage-sections-feature-description">
                        Add one or multiple sections for any class
                        simultaneously
                      </p>
                    </div>
                  </div>

                  <div className="manage-sections-feature-item">
                    <div className="manage-sections-feature-icon">
                      <FontAwesomeIcon icon={faCog} />
                    </div>
                    <div className="manage-sections-feature-content">
                      <h4 className="manage-sections-feature-title">
                        Configure Section Details
                      </h4>
                      <p className="manage-sections-feature-description">
                        Set section codes, capacities, and other relevant
                        parameters
                      </p>
                    </div>
                  </div>
                </div>

                <div className="manage-sections-card-description">
                  <p className="manage-sections-description-text">
                    Use this option to create new class sections. Perfect for
                    setting up sections at the beginning of a term or when
                    expanding class offerings.
                  </p>
                </div>

                <button
                  className="manage-sections-action-btn manage-sections-primary-btn"
                  onClick={() => navigate("/addSections")}
                >
                  <FontAwesomeIcon icon={faPlusCircle} />
                  <span className="manage-sections-btn-text">
                    Add New Sections
                  </span>
                </button>
              </div>

              {/* View/Update Sections Card (Right - 45%) */}
              <div className="manage-sections-card manage-sections-view-card">
                <div className="manage-sections-card-header">
                  <div className="manage-sections-header-icon-wrapper">
                    <FontAwesomeIcon
                      icon={faList}
                      className="manage-sections-card-icon"
                    />
                  </div>
                  <div>
                    <h3 className="manage-sections-card-title">
                      View & Manage Sections
                    </h3>
                    <p className="manage-sections-card-subtitle">
                      Complete control over existing sections with full CRUD
                      operations
                    </p>
                  </div>
                </div>

                <div className="manage-sections-card-features">
                  <div className="manage-sections-feature-item">
                    <div className="manage-sections-feature-icon">
                      <FontAwesomeIcon icon={faEye} />
                    </div>
                    <div className="manage-sections-feature-content">
                      <h4 className="manage-sections-feature-title">
                        View All Sections
                      </h4>
                      <p className="manage-sections-feature-description">
                        Browse through all existing sections with detailed
                        information
                      </p>
                    </div>
                  </div>

                  <div className="manage-sections-feature-item">
                    <div className="manage-sections-feature-icon">
                      <FontAwesomeIcon icon={faEdit} />
                    </div>
                    <div className="manage-sections-feature-content">
                      <h4 className="manage-sections-feature-title">
                        Update & Modify
                      </h4>
                      <p className="manage-sections-feature-description">
                        Edit section details, update configurations, or modify
                        settings
                      </p>
                    </div>
                  </div>
                </div>

                <div className="manage-sections-card-description">
                  <p className="manage-sections-description-text">
                    This option provides full administrative control over all
                    sections. View, update, or remove sections as needed
                    throughout the academic year.
                  </p>
                </div>

                <button
                  className="manage-sections-action-btn manage-sections-secondary-btn"
                  onClick={() => navigate("/viewSections")}
                >
                  <FontAwesomeIcon icon={faEye} />
                  <span className="manage-sections-btn-text">
                    View/Update Sections
                  </span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ManageSections;
